import { Helmet } from 'react-helmet-async';
// @mui
import { styled } from '@mui/material/styles';
import { Link, Container, Typography, Divider, Stack, Button } from '@mui/material';
// hooks
import useResponsive from '../hooks/useResponsive';
// components
import Logo from '../components/logo';
import Iconify from '../components/iconify';
// sections
import { LoginForm } from '../sections/auth/login';
import LogoLogin from 'src/components/logo/LogoLogin';

// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
  idth: '100%',
}));

const StyledSection = styled('div')(({ theme }) => ({
  width: '100%',
  //maxWidth: 480,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  boxShadow: theme.customShadows.card,
  backgroundColor: theme.palette.background.default,
}));

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  //minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  marginTop: ".5rem",//theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function LoginPage({setToken}) {
  const mdUp = useResponsive('up', 'md');

  return (
    <>
      <Helmet>
        <title> Login </title>
      </Helmet>

      <StyledRoot>
        <Stack>
        <LogoLogin
          sx={{
            //position: 'absolute',
            margin: 'auto',
            marginTop: '1rem'
            //left: { xs: 16, sm: 24, md: 40 },
          }}
        />

        <Container maxWidth="sm">
          <StyledContent>
            <Typography variant="h4" gutterBottom>
              Accedi
            </Typography>

            <br/>
            <LoginForm setToken={setToken} />
          </StyledContent>
        </Container>
        </Stack>
      </StyledRoot>
    </>
  );
}
